import {
  Button,
  ButtonColor,
  FontWeight,
  Grid, Image, Spacing, SpacingName,
  Typography,
} from '@doveit/lego';
import React from 'react';
import { requireFromStaticAsset } from '../../utils/assetsUtils';
import Markdown from '../markdown/Markdown';
import { CTA } from '../../types';

export type CTAWithOnCLick = CTA & { onClick: VoidFunction };

export interface BasicStripeProps extends React.AriaAttributes {
  title: string,
  subtitle?: string,
  description: string,
  image: {
    url: string,
    alt: string,
  },
  cta?: CTAWithOnCLick,
}

const BasicStripe: React.FC<BasicStripeProps> = (props) => {
  const {
    title, subtitle, description, image, cta,
  } = props;

  return (
    <Grid gutter={SpacingName.MEDIUM}>
      <Grid.Unit size={{ MD: 1 / 3 }}>
        <Image
          src={requireFromStaticAsset(image.url)}
          alt={image.alt}
          width="100%"
          fit
          lazyLoad
          overflow
        />
      </Grid.Unit>
      <Grid.Unit size={{ MD: 2 / 3 }}>
        <Typography.H3 color="brand.primary" uppercase>
          {title}
        </Typography.H3>
        {subtitle && (
          <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
            <Typography.H4>
              {subtitle}
            </Typography.H4>
          </Spacing>
        )}
        <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
          <Typography.H4 tagName="div" fontWeight={FontWeight.LIGHT}>
            <Markdown>
              {description}
            </Markdown>
          </Typography.H4>
        </Spacing>
        {cta && (
          <Spacing margin={[SpacingName.SMALL, 0, 0]}>
            <Button
              label={cta.label}
              dataRef={cta.dataRef}
              onClick={cta.onClick}
              color={ButtonColor.PRIMARY}
            />
          </Spacing>
        )}
      </Grid.Unit>
    </Grid>
  );
};

export default BasicStripe;
